import { createAction } from '@reduxjs/toolkit'

export const fetchCoupons = createAction('coupon/fetchCoupons')
export const updateCoupon = createAction('coupon/updateCoupon')
export const createCoupon = createAction('coupon/createCoupon')
export const deleteCoupon = createAction('coupon/deleteCoupon')
